import { render, staticRenderFns } from "./CarrosselComponent2.vue?vue&type=template&id=f3689a6e&scoped=true&"
import script from "./CarrosselComponent2.vue?vue&type=script&lang=js&"
export * from "./CarrosselComponent2.vue?vue&type=script&lang=js&"
import style0 from "./CarrosselComponent2.vue?vue&type=style&index=0&id=f3689a6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3689a6e",
  null
  
)

export default component.exports